import { render, staticRenderFns } from "./switchPicker.vue?vue&type=template&id=3c320781"
import script from "./switchPicker.vue?vue&type=script&lang=js"
export * from "./switchPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports